/*
 * Recently Viewed — DISPLAY ENGINE (carousel) | eroticshop.com.tr
 * localStorage → filtrele → ilk `max` PARALEL fetch → enjekte.
 * Mobil swipe; masaüstü `show` görünür + ok navigasyonu. Lazy + akıllı refresh.
 */
(function () {
  'use strict';

  if (customElements.get('recently-viewed')) return;

  var DEBOUNCE_MS = 400;

  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.show        = parseInt(this.dataset.show, 10) || 6;
      this.max         = parseInt(this.dataset.max, 10) || 10;
      this.min         = parseInt(this.dataset.min, 10) || 1;
      this.cardSection = this.dataset.cardSection || 'recently-viewed-card';
      this.currentId   = String(this.dataset.currentId || '');
      this.entries     = [];
      this.cartIds     = [];
      this.cache       = [];
      this._activated  = false;
      this._io         = null;
      this._unsub      = null;
      this._t          = null;
      this._list        = null;
      this._prev        = null;
      this._next        = null;
      this._arrowsBound = false;
      this._raf         = null;
      this._onResize    = null;
    }

    connectedCallback() {
      /* Per-user anahtar: misafirde (cid yok) bölüm kalıcı gizli, sıfır iş */
      var cid = this.dataset.customerId || '';
      if (!cid) { this._hide(); return; }
      this.lsKey = 'ero_rv__' + cid;
      this.entries = this._readLS();
      // Eşik: yeterli geçmiş yoksa hiç kurma (sub-eşik ziyaretçi = SIFIR fetch)
      if (this.entries.length < this.min) { this._hide(); return; }

      if ('IntersectionObserver' in window) {
        var self = this;
        this._io = new IntersectionObserver(function (ents) {
          if (ents.some(function (e) { return e.isIntersecting; })) {
            self._io.disconnect(); self._io = null; self._activate();
          }
        }, { rootMargin: '300px 0px' });
        this._io.observe(this);
      } else {
        this._activate();
      }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._unsub) this._unsub();
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      clearTimeout(this._t);
    }

    _readLS() {
      try {
        var arr = JSON.parse(localStorage.getItem(this.lsKey));
        return Array.isArray(arr) ? arr.filter(function (e) { return e && e.id && e.handle; }) : [];
      } catch (e) { return []; }
    }

    _wrap()     { return this.closest('.recently-viewed'); }
    _hide()     { var w = this._wrap(); if (w) w.setAttribute('hidden', ''); }
    _showWrap() { var w = this._wrap(); if (w) w.removeAttribute('hidden'); }

    _excludeSet() {
      var set = {};
      if (this.currentId) set[this.currentId] = true;
      this.cartIds.forEach(function (id) { set[id] = true; });
      return set;
    }

    _activate() {
      if (this._activated) return;
      this._activated = true;
      var self = this;

      this._fetchCartIds()
        .then(function () {
          var exclude = self._excludeSet();
          var handles = self.entries.filter(function (e) { return !exclude[String(e.id)]; }).slice(0, self.max);
          if (handles.length < self.min) { self._hide(); return null; }
          return Promise.all(handles.map(function (e) { return self._fetchCard(e); }));
        })
        .then(function (results) {
          if (!results) return;
          self.cache = results.filter(function (r) { return r && r.li; });
          if (!self.cache.length) { self._hide(); return; }
          self._render();
          self._initArrows();
          self._subscribeCart();
        })
        .catch(function () { self._hide(); });
    }

    _fetchCartIds() {
      var self = this;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (cart) {
          self.cartIds = (cart.items || []).map(function (it) { return String(it.product_id); });
        })
        .catch(function () { self.cartIds = []; });
    }

    _fetchCard(entry) {
      var url = '/products/' + encodeURIComponent(entry.handle) + '?section_id=' + encodeURIComponent(this.cardSection);
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var li = new DOMParser().parseFromString(html, 'text/html').querySelector('.rv__item');
          return li ? { id: String(entry.id), li: li } : null;
        })
        .catch(function () { return null; });
    }

    _render() {
      var listEl = this.querySelector('[data-rv-list]');
      if (!listEl) return;
      var exclude = this._excludeSet();

      // Carousel: filtrelenmiş TÜM cache basılır (max'a kadar) — fazlası kaydırılır
      var visible = this.cache.filter(function (item) { return !exclude[item.id]; });
      if (visible.length < this.min) { this._hide(); return; }

      listEl.innerHTML = '';
      // LCP düzeltmesi (16 Tem): ilk görünümdeki kartların görseli lazy kalmasın —
      // enjeksiyon anında hemen insin. fetchpriority BİLİNÇLİ verilmedi: bu section
      // PDP'de de kullanılıyor, galeri LCP görseliyle bant genişliği yarışına girmesin.
      // Görünüm dışındaki carousel kartları lazy kalır (over-fetch yok).
      var perView = this.show;
      visible.forEach(function (item, index) {
        var li = item.li.cloneNode(true);
        if (index < perView) {
          var img = li.querySelector('img[loading="lazy"]');
          if (img) { img.loading = 'eager'; }
        }
        listEl.appendChild(li);
      });
      listEl.setAttribute('aria-busy', 'false');
      this._showWrap();
      this._updateArrows();
    }

    /* ── Carousel ok navigasyonu ── */
    _initArrows() {
      if (this._arrowsBound) { this._updateArrows(); return; }
      this._list = this.querySelector('[data-rv-list]');
      this._prev = this.querySelector('.rv__arrow--prev');
      this._next = this.querySelector('.rv__arrow--next');
      if (!this._list || !this._prev || !this._next) return;

      var self = this;
      this._prev.addEventListener('click', function () { self._scrollByPage(-1); });
      this._next.addEventListener('click', function () { self._scrollByPage(1); });

      this._list.addEventListener('scroll', function () {
        if (self._raf) return;
        self._raf = window.requestAnimationFrame(function () {
          self._raf = null; self._updateArrows();
        });
      }, { passive: true });

      this._onResize = function () { self._updateArrows(); };
      window.addEventListener('resize', this._onResize, { passive: true });

      this._arrowsBound = true;
      this._updateArrows();
    }

    _scrollByPage(dir) {
      if (!this._list) return;
      var amount = Math.round(this._list.clientWidth * 0.8) * dir;
      this._list.scrollBy({ left: amount, behavior: 'smooth' });
    }

    _updateArrows() {
      if (!this._list || !this._prev || !this._next) return;
      var l = this._list;
      var overflow = (l.scrollWidth - l.clientWidth) > 2;
      if (!overflow) {
        this._prev.setAttribute('hidden', '');
        this._next.setAttribute('hidden', '');
        return;
      }
      this._prev.toggleAttribute('hidden', l.scrollLeft <= 2);
      this._next.toggleAttribute('hidden', (l.scrollLeft + l.clientWidth) >= (l.scrollWidth - 2));
    }

    /* ── Akıllı refresh ── */
    _subscribeCart() {
      var self = this;
      if (typeof subscribe === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        this._unsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function () { self._onCartUpdate(); });
      }
    }

    _onCartUpdate() {
      var self = this;
      clearTimeout(this._t);
      this._t = setTimeout(function () {
        self._fetchCartIds().then(function () { self._render(); });
      }, DEBOUNCE_MS);
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
})();